<template>
  <v-card v-if="accountData != null" flat class="pa-3 mt-2">
    <v-card-text class="d-flex">
      <!-- upload photo -->
      <div>
        <avatar-image-component :edit="adminProfileStore.id == accountData.id" :avatarUrl="accountData.avatar" :user="accountData"></avatar-image-component>
      </div>
    </v-card-text>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        class="multi-col-validation mt-6"
        lazy-validation
      >
        <v-row>
            <v-col md="6" cols="12">
              <v-text-field
                v-model="accountData.name"
                :label="$t('user_cards.name')"
              dense
              outlined
              required
              :rules="nameRules"
            ></v-text-field>
          </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="accountData.email"
                :label="$t('user_cards.email')"
              :disabled="accountData.id != 1 && userType !== 'student'"
              dense
              outlined
              required
              :rules="emailRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
              <v-select
              disabled
                v-model="accountData.role_id"
              dense
              outlined
                :label="$t('user_cards.role')"
              :items="roles"
              item-text="role"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
              <v-select
                v-model="accountData.status_id"
              :disabled="accountData.id == 1"
              dense
              outlined
                :label="$t('user_cards.status')"
              :items="statuses"
              item-text="status"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
              <v-text-field
                v-model="accountData.tel_number"
                outlined
                dense
                :label="$t('user_cards.phone_number')"
              :rules="phoneRules"
            ></v-text-field>
          </v-col>

            <v-col cols="12" md="6" v-if="userType == 'student'">
              <v-text-field
                v-model="accountData.student_identification"
                outlined
                dense
                :label="$t('user_cards.student_id')"
            ></v-text-field>
          </v-col>
          <v-col v-else-if="userType == 'school' || (userType == 'guardian' && accountData.role_id==4)">
            <v-text-field
              v-model="accountData.balance"
              :disabled="userType == 'guardian' && accountData.role_id==4"
              outlined
              dense
              :label="$t('user_cards.balance')"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-btn color="primary" class="me-3 mt-4" @click="saveUser">
              {{ $t('common.save_changes') }}
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              @click="cancel"
            >
              {{ $t('common.cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

import AvatarImageComponent from '../../../components/AvatarImageComponent.vue'
import { mdiAlertOutline, mdiCloudUploadOutline } from "@mdi/js";
import { adminProfileStore } from "@/utils/helpers";

export default {
  components: {
    AvatarImageComponent
  },
  setup() {
    return { adminProfileStore }
  },
  props: {
    accountData: {
      type: Object,
      default: () => {},
    },
    userType: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return {
      valid: true,
      nameRules: [(v) => !!v || this.$t('common.required')],
      emailRules: [
        v => !!v || this.$t('auth.email_required'),
        v => /.+@.+\..+/.test(v) || this.$t('auth.email_invalid'),
      ],
      phoneRules: [
        v => /^(|\d)+$/.test(v) || this.$t('user_cards.phone_invalid'),
      ],
      statuses: [
        { status: this.$t('statuses.active'), value: 1 },
        { status: this.$t('statuses.pending'), value: 2 },
        { status: this.$t('statuses.suspended'), value: 3 },
      ],
      roles: [
        { role: this.$t('roles.admin'), value: 1},
        { role: this.$t('roles.school'), value: 2 },
        { role: this.$t('roles.driver'), value: 3 },
        { role: this.$t('roles.parent'), value: 4},
        { role: this.$t('roles.guardian'), value: 5},
        { role: this.$t('roles.student'), value: 6}
      ],
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    saveUser() {
      if (!this.validate()) return;
      this.$emit("save-user-info");
    },
    cancel()
    {
      this.$router.go(-1);
    }
  },
};
</script>
